import { defineMessages } from 'react-intl.macro';

export const userMessages = defineMessages({
  title: {
    id: 'user.title',
    defaultMessage: 'Detail uživatele',
  },
  btnCloseDialog: {
    id: 'user.btn.closedialog',
    defaultMessage: 'Zavřít',
  },
  nameLabel: {
    id: 'user.name.label',
    defaultMessage: 'Jméno',
  },
  surnameLabel: {
    id: 'user.surname.label',
    defaultMessage: 'Příjmení',
  },
  emailLabel: {
    id: 'user.email.label',
    defaultMessage: 'E-mail',
  },
  phoneLabel: {
    id: 'user.phone.label',
    defaultMessage: 'Telefon',
  },
  icoLabel: {
    id: 'user.ico.label',
    defaultMessage: 'IČ uživatele',
  },
  accountNameLabel: {
    id: 'user.accountName.label',
    defaultMessage: 'Účet',
  },
  accountTypeLabel: {
    id: 'user.accountType.label',
    defaultMessage: 'Typ účtu',
  },
  organizationLabel: {
    id: 'user.organization.label',
    defaultMessage: 'Organizace',
  },
  rolesLabel: {
    id: 'user.roles.label',
    defaultMessage: 'Role',
  },
  noteLabel: {
    id: 'user.note.label',
    defaultMessage: 'Poznámka',
  },
});

export const userQueryMessages = defineMessages({
  loadQueryStateFail: {
    id: 'user.alert.load.fail',
    defaultMessage: 'Zobrazení informací o uživateli se nepovedlo. Zkuste to prosím později.',
  },
  loadQueryStateWaiting: {
    id: 'user.alert.load.waiting',
    defaultMessage: 'Čekejte prosím...',
  },
});
